export default __webpack_public_path__ + "static/media/mastercard.6a00550f.svg";